import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import ProductTableInCart from "../card/ProductTableInCart";
import { ToastContainer, toast } from "react-toastify";
import { userCart } from "../function/users";
import { listPromotions } from "../function/promotion";
import { ShoppingCartOutlined, SafetyCertificateOutlined } from "@ant-design/icons";
import "./Cart.css";

const Cart = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { cart, user } = useSelector((state) => ({ ...state }));
  const [promotions, setPromotions] = React.useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 820);

  const loadPromotions = () => {
    listPromotions().then((res) => {
      setPromotions(res.data);
    });
  };

  useEffect(() => {
    loadPromotions();
  }, []);
  useEffect(() => {
  const handleResize = () => setIsMobile(window.innerWidth <= 820);
  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, []);

  const getBuyGetDiscount = (item, promotions) => {
    for (const promo of promotions) {
      if (promo.products.some((p) => p._id === item._id || p === item._id)) {
        const buyGet = promo.discount.find((d) => d.type === "buyGetDiscount");
        if (buyGet) return buyGet;
      }
    }
    return null;
  };

  const getFinalPrice = (item) => {
    let price = item.discountedPrice || item.price;
    const buyGet = getBuyGetDiscount(item, promotions);
    if (buyGet && item.count >= buyGet.minQuantity) {
      price = price * (1 - buyGet.value / 100);
    }
    return price;
  };

  const getOriginalTotal = () => {
    return cart.reduce((total, item) => {
      return total + (item.originalPrice || item.price) * item.count;
    }, 0);
  };

  const getTotal = () => {
    return cart.reduce((total, item) => {
      return total + getFinalPrice(item) * item.count;
    }, 0);
  };

  const getTotalSavings = () => getOriginalTotal() - getTotal();

  const handleSaveOrder = async () => {
    for (let item of cart) {
      if (!item.isActive) {
      toast.error(`สินค้า ${item.title} ยังไม่พร้อมจำหน่าย จะกลับมาเร็วๆ นี้ กรุณานำออกจากตะกร้า`);
      return;
    }
    if (item.count <= 0 || item.count > item.quantity) {
      toast.error(`สินค้า ${item.title} หมดหรือเกินจำนวนที่มีอยู่`);
      return;
    }
    }

    const adjustedCart = cart.map((item) => ({
      ...item,
      _id: item._id,
      count: item.count,
      price: getFinalPrice(item),
      type: item.product
        ? "product"
        : item.productservice
        ? "productservice"
        : item.productmenu
        ? "productmenu"
        : "",
    }));

    if (user) {
      userCart(user.token, adjustedCart)
        .then((res) => {
          navigate("/checkout");
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      navigate("/login");
    }
  };

  const totalItems = cart.reduce((sum, item) => sum + item.count, 0);
  const savings = getTotalSavings();

  return (
    <>
      <div className="cart-page">
        <div className={isMobile ? "" : "cart-container"}>

          
          <div className="cart-left">
            <div className="cart-header">
              <ShoppingCartOutlined className="cart-header-icon" />
              <h5 className="cart-title">ตะกร้าสินค้า</h5>
              {cart.length > 0 && (
                <span className="cart-badge">{totalItems} ชิ้น</span>
              )}
            </div>

            {!cart.length ? (
              <div className="cart-empty">
                <ShoppingCartOutlined className="cart-empty-icon" />
                <p className="cart-empty-text">ไม่มีสินค้าในตะกร้า</p>
                <Link to="/" className="btn-continue">
                  เลือกสินค้าต่อ
                </Link>
              </div>
            ) : (
              <div className="cart-items-wrapper">
                <table className="cart-table">
                  <thead>
                    <tr>
                      <th>สินค้า</th>
                      <th>ชื่อ</th>
                      <th>ราคา</th>
                      <th>จำนวน</th>
                      <th>ลบ</th>
                    </tr>
                  </thead>
                  {cart.map((item) => (
                    <ProductTableInCart
                      key={item._id}
                      item={item}
                      promotions={promotions}
                      getBuyGetDiscount={getBuyGetDiscount}
                    />
                  ))}
                </table>
              </div>
            )}
          </div>

          {/* ---- ฝั่งขวา: สรุปคำสั่งซื้อ ---- */}
          <div className="cart-right">
            <div className="summary-card">
              <h5 className="summary-title">สรุปคำสั่งซื้อ</h5>
              <hr className="summary-divider" />

              <div className="summary-items">
                {cart.map((item, index) => {
                  const finalPrice = getFinalPrice(item);
                  return (
                    <div key={index} className="summary-item-row">
                      <span className="summary-item-name">
                        {item.title}
                        <span className="summary-item-qty"> × {item.count}</span>
                      </span>
                      <span className="summary-item-price">
                        {(finalPrice * item.count).toLocaleString("th-TH", {
                          minimumFractionDigits: 2,
                        })}{" "}
                        บาท
                      </span>
                    </div>
                  );
                })}
              </div>

              <hr className="summary-divider" />

              <div className="summary-totals">
                {savings > 0 && (
                  <div className="summary-row">
                    <span className="summary-label">ราคาเต็ม</span>
                    <span className="summary-value summary-original">
                      {getOriginalTotal().toLocaleString("th-TH", {
                        minimumFractionDigits: 2,
                      })}{" "}
                      บาท
                    </span>
                  </div>
                )}
                {savings > 0 && (
                  <div className="summary-row">
                    <span className="summary-label">ส่วนลดรวม</span>
                    <span className="summary-value summary-discount">
                      −{savings.toLocaleString("th-TH", {
                        minimumFractionDigits: 2,
                      })}{" "}
                      บาท
                    </span>
                  </div>
                )}
                <div className="summary-row">
                  <span className="summary-label">ค่าจัดส่ง</span>
                  <span className="summary-value summary-free">ฟรี</span>
                </div>
              </div>

              <hr className="summary-divider" />

              <div className="summary-total-row">
                <span className="summary-total-label">ยอดรวมทั้งหมด</span>
                <span className="summary-total-value">
                  {getTotal().toLocaleString("th-TH", {
                    minimumFractionDigits: 2,
                  })}{" "}
                  บาท
                </span>
              </div>

              <div className="summary-actions">
                {user ? (
                  <button
                    className="btn-checkout"
                    onClick={handleSaveOrder}
                    disabled={!cart.length}
                  >
                    ดำเนินการชำระเงิน
                  </button>
                ) : (
                  <Link to="/login" state="cart" className="btn-checkout btn-checkout-login">
                    เข้าสู่ระบบเพื่อชำระเงิน
                  </Link>
                )}

                <Link to="/" className="btn-continue-shopping">
                  เลือกสินค้าต่อ
                </Link>
              </div>

              <div className="summary-secure">
                <SafetyCertificateOutlined />
                <span>ปลอดภัยด้วยระบบ SSL</span>
              </div>
            </div>
          </div>

        </div>
      </div>
      <ToastContainer position="bottom-right" />
    </>
  );
};

export default Cart;